import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const popularLinks = [
    { to: "/", label: "Browse rooms for rent" },
    { to: "/roommates", label: "Find Indian roommates" },
    { to: "/indian-areas-in-london", label: "Best areas for Indians in London" },
    { to: "/uk-essentials-for-indians", label: "UK essentials checklist" },
    { to: "/airport-cabs", label: "Airport cabs" },
    { to: "/uk-tour-trips", label: "UK tour trips" },
];

// Catch-all for unknown URLs. Hosting serves index.html with a 200 for every
// path, so noindex is what stops Google indexing mistyped or old links.
function NotFound() {
    return (
        <>
            <Helmet>
                <title>Page not found (404) | IndianFlatmates</title>
                <meta name="description" content="The page you were looking for could not be found." />
                <meta name="robots" content="noindex" />
            </Helmet>

            <div className="container mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md my-6">
                <div className="max-w-2xl mx-auto text-center">
                    <p className="text-6xl font-extrabold text-indigo-600 dark:text-indigo-400 mb-2">404</p>
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-gray-100 mb-3">
                        Sorry, we couldn't find that page
                    </h1>
                    <p className="text-gray-600 dark:text-gray-400 mb-8">
                        The link may be old, or the listing may have been removed. Try one of these instead:
                    </p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
                        {popularLinks.map((link) => (
                            <li key={link.to}>
                                <Link
                                    to={link.to}
                                    className="block px-4 py-3 rounded-lg bg-gray-50 dark:bg-gray-900 hover:bg-indigo-50 dark:hover:bg-gray-700 text-indigo-700 dark:text-indigo-300 font-medium transition-colors"
                                >
                                    {link.label} →
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default NotFound;
